import React from 'react';

// Popup imports
class ThumbnailItem extends React.Component {
    onClick = () => {
        const { onSelect, uuid } = this.props;

        onSelect(uuid);
    };

    render = () => {
        const { index, thumbnail, isCurrent } = this.props;

        if (thumbnail === undefined) {
            return <></>;
        }

        const activeClass = isCurrent ? ' active' : '';

        const lastClass = (index + 1) % 3 === 0 ? ' last' : '';

        return (
            <div className={`thumbnail-item${activeClass}${lastClass}`} type="button" onClick={this.onClick}>
                <img src={`${thumbnail}`} alt="Thumbnail" />
            </div>
        );
    };
}

export default ThumbnailItem;
